import React, { useState } from 'react';
import './ActMenu.css';

const InvoiceMenu = ({
    onGenerate,
    onSelectMonth,
    onSelectAll,
    onClose,
    selectedMonth,
    monthsList = [],
    orders = [],
    selectedOrders = []
}) => {
    const [showMonthModal, setShowMonthModal] = useState(false);

    // Определяем, все ли заказы выбраны
    const allOrderIds = orders.map(order => order.id);
    const allSelected = allOrderIds.length > 0 && allOrderIds.every(id => selectedOrders.includes(id));
    const buttonText = allSelected ? 'Снять все' : 'Все';

    return (
        <div className="act-menu">
            {/* Заголовок */}
            <div className="act-menu-header">
                <span className="act-menu-title">
                    Выберите заказы для счета!
                </span>
                <button
                    className="act-menu-close"
                    onClick={onClose}
                >
                    ✕
                </button>
            </div>

            {/* Кнопка Сформировать */}
            <button
                className="act-menu-generate"
                onClick={onGenerate}
            >
                Сформировать
            </button>

            {/* Ряд кнопок: Месяц | Все */}
            <div className="act-menu-buttons">
                {/* Кнопка Месяц */}
                <button
                    className="act-menu-month"
                    onClick={() => setShowMonthModal(true)}
                >
                    {selectedMonth || 'За месяц'}
                </button>

                {/* Кнопка Все */}
                <button
                    className="act-menu-all"
                    onClick={onSelectAll}
                >
                    {buttonText}
                </button>
            </div>

            {/* Модалка выбора месяца */}
            {showMonthModal && (
                <div className="act-menu-modal-overlay" onClick={() => setShowMonthModal(false)}>
                    <div className="act-menu-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="act-menu-modal-list">
                            {monthsList.map((month, idx) => (
                                <button
                                    key={idx}
                                    className="act-menu-modal-item"
                                    onClick={() => {
                                        onSelectMonth(month);
                                        setShowMonthModal(false);
                                    }}
                                >
                                    {month}
                                </button>
                            ))}
                        </div>
                        <button
                            className="act-menu-modal-cancel"
                            onClick={() => setShowMonthModal(false)}
                        >
                            Отмена
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InvoiceMenu;

